import React, { useContext, useState } from "react";
import {
	Drawer,
	ListItem,
	ListItemIcon,
	ListItemText,
	Paper,
} from "@material-ui/core";

import { makeStyles, useTheme } from "@material-ui/core/styles";

import { NavLink } from "react-router-dom";

// Icons
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";
import EuroIcon from "@material-ui/icons/Euro";
import ArchiveIcon from "@material-ui/icons/Archive";
import ChatIcon from "@material-ui/icons/Chat";
// import { PageContext } from "../../contexts/PageContext";

import { UserContext } from "../../contexts/UserContext";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
	drawer: {

	},
	drawerPaper: {
		width: drawerWidth,

	},
	drawerInner: {

	},
	menuItemGroup: {

	},
	menuItem: {
		textDecoration: "none"
	},
	menuItemSecondary: {
		textDecoration: "none",
		marginLeft: theme.spacing(2)
	},
	menuItemText: {
		color: theme.palette.primary.main,
	},
	menuItemIcon: {
		width: 38,
		minWidth: 38
	},
}));

export default function Navigation(props) {
	// const pageContext = useContext(PageContext);
	const userContext = useContext(UserContext);
	const theme = useTheme();
	const classes = useStyles();
	const { menuOpen, setMenuOpen } = props;
	const isBackoffice = userContext.user.role === "backoffice";

	let drawer = (
		<div className={classes.drawerInner}>
			<Paper className={classes.menuItemGroup} elevation={0}>
				{/* <NavLink
					to="/"
					className={classes.menuItem}
					activeClassName="active" 
					onClick={()=>setMenuOpen(false)}
				>
					<ListItem button>
						<ListItemIcon className={classes.menuItemIcon}>
							<PersonIcon color="secondary" fontSize="small"/>
						</ListItemIcon>
						<ListItemText
							primary="Dashboard"
							classes={{ primary: classes.menuItemText }}
						/>
					</ListItem>
				</NavLink> */}
				{!isBackoffice && (
					<>
						<NavLink
							to="/finanzierungen/"
							className={classes.menuItem}
							activeClassName="active"
							onClick={() => setMenuOpen(false)}
						>
							<ListItem button>
								<ListItemIcon className={classes.menuItemIcon}>
									<EuroIcon color="secondary" fontSize="small" />
								</ListItemIcon>
								<ListItemText
									primary="Finanzierungen"
									classes={{ primary: classes.menuItemText }}
								/>
							</ListItem>
						</NavLink>
						<NavLink
							to="/finanzierungsarchiv/"
							className={classes.menuItem}
							activeClassName="active"
							onClick={() => setMenuOpen(false)}
						>
							<ListItem
								className={classes.menuItemSecondary}
								button>
								<ListItemIcon className={classes.menuItemIcon}>
									<ArchiveIcon color="secondary" fontSize="small" />
								</ListItemIcon>
								<ListItemText
									primary="Archiv"
									classes={{ primary: classes.menuItemText }}
								/>
							</ListItem>
						</NavLink>
					</>
				)}
				{/* <NavLink
					to="/kreditvergleich/"
					className={classes.menuItem}
					activeClassName="active"
					onClick={() => setMenuOpen(false)}
				>
					<ListItem button>
						<ListItemIcon className={classes.menuItemIcon}>
							<ViewColumnIcon color="secondary" fontSize="small" />
						</ListItemIcon>
						<ListItemText
							primary="Kreditvergleich Infoblatt"
							classes={{ primary: classes.menuItemText }}
						/>
					</ListItem>
				</NavLink> */}
				{/* <NavLink
					to="/profile/"
					className={classes.menuItem}
					activeClassName="active" 
					onClick={()=>setMenuOpen(false)}
				>
					<ListItem button>
						<ListItemIcon className={classes.menuItemIcon}>
							<PersonIcon color="secondary" fontSize="small"/>
						</ListItemIcon>
						<ListItemText
							primary="Profil"
							classes={{ primary: classes.menuItemText }}
						/>
					</ListItem>
				</NavLink> */}
				{userContext.user.role === "administrator" &&
					<>
						<NavLink
							to="/einstellungen/"
							className={classes.menuItem}
							activeClassName="active"
							onClick={() => setMenuOpen(false)}
						>
							<ListItem button>
								<ListItemIcon className={classes.menuItemIcon}>
									<SettingsIcon color="secondary" fontSize="small" />
								</ListItemIcon>
								<ListItemText
									primary="Einstellungen"
									classes={{ primary: classes.menuItemText }}
								/>
							</ListItem>
						</NavLink>
						<NavLink
							to="/benachrichtigungen/"
							className={classes.menuItem}
							activeClassName="active"
							onClick={() => setMenuOpen(false)}
						>
							<ListItem button>
								<ListItemIcon className={classes.menuItemIcon}>
									<ChatIcon color="secondary" fontSize="small" />
								</ListItemIcon>
								<ListItemText
									primary="Benachrichtigungen"
									classes={{ primary: classes.menuItemText }}
								/>
							</ListItem>
						</NavLink>

					</>
				}
				{["administrator", "backoffice"].includes(userContext.user.role) && (
					<NavLink
						to="/benutzer/"
						className={classes.menuItem}
						activeClassName="active"
						onClick={() => setMenuOpen(false)}
					>
						<ListItem button>
							<ListItemIcon className={classes.menuItemIcon}>
								<PersonIcon color="secondary" fontSize="small" />
							</ListItemIcon>
							<ListItemText
								primary="Benutzerverwaltung"
								classes={{ primary: classes.menuItemText }}
							/>
						</ListItem>
					</NavLink>
				)}
			</Paper>
		</div>
	);

	return (
		<nav className={classes.drawer}>
			<Drawer
				variant="temporary"
				open={menuOpen}
				anchor="right"
				onClose={() => setMenuOpen(false)}
				classes={{
					paper: classes.drawerPaper,
				}}
				ModalProps={{
					keepMounted: true,
				}}
			>
				{drawer}
			</Drawer>
		</nav>
	);
}
